import { MapPin, Phone, Clock } from "lucide-react";

const locations = [
  {
    name: "Kamineni Hospitals",
    area: "Kanuru, Vijayawada",
    timing: "9 AM - 5 PM",
    phone: "70756 59696",
    phoneRaw: "+917075659696",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15303!2d80.5897!3d16.5246!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fb410b478745%3A0x15b31dcfb33e7c94!2sKamineni%20Hospitals%2C%20Vijayawada!5e0!3m2!1sen!2sin!4v1",
  },
  {
    name: "Divi Multi Speciality Surgical Clinic",
    area: "Penamaluru, Vijayawada",
    timing: "5 PM - 9 PM",
    phone: "78429 88596",
    phoneRaw: "+917842988596",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3826.0713277318823!2d80.7176486749132!3d16.47192558426744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fb9057619ea7%3A0x136a7166e87abbe1!2sDIVI%20MULTISPECIALITY%20SURGICAL%20CLINIC!5e0!3m2!1sen!2sin!4v1772978920469!5m2!1sen!2sin",
  },
];

export default function Locations() {
  return (
    <section id="locations" data-testid="locations-section" className="py-16 md:py-24 bg-clinical">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-12">
          <p className="reveal text-teal font-medium text-sm uppercase tracking-widest mb-3">Consultation Locations</p>
          <h2 className="reveal delay-1 font-heading font-bold text-3xl md:text-4xl text-navy tracking-tight">
            Visit Us at Our Clinics
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {locations.map((loc, i) => (
            <div
              key={loc.name}
              data-testid={`location-card-${i}`}
              className={`reveal delay-${i + 1} bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden`}
            >
              <div className="aspect-video bg-slate-100">
                <iframe
                  src={loc.mapSrc}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`Map - ${loc.name}`}
                  className="w-full h-full"
                />
              </div>
              <div className="p-6 space-y-3">
                <h3 className="font-heading font-bold text-navy text-lg">{loc.name}</h3>
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-sm text-slate-600">
                    <MapPin className="w-4 h-4 text-teal flex-shrink-0" strokeWidth={1.5} />
                    {loc.area}
                  </div>
                  <div className="flex items-center gap-2 text-sm text-slate-600">
                    <Clock className="w-4 h-4 text-teal flex-shrink-0" strokeWidth={1.5} />
                    {loc.timing}
                  </div>
                  <a
                    href={`tel:${loc.phoneRaw}`}
                    className="flex items-center gap-2 text-sm text-teal font-medium hover:text-teal-dark transition-colors"
                  >
                    <Phone className="w-4 h-4 flex-shrink-0" strokeWidth={1.5} />
                    {loc.phone}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
